/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewState {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return ViewState.fixupPrototype; }

    static newInstance(model: Partial<ViewState>): ViewState {
        let obj = Object.assign(new ViewState(), model);
        ViewState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewState>): ViewState {
        if (!model) return null;
        return ViewState.newInstance(<ViewState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewState) {
        if (!obj) return;

        models.ViewState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewState): boolean {
        switch (obj.__type)
        {
            case "DashboardViewState":
                Object.setPrototypeOf(obj, models.DashboardViewState.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ViewState)[] {
        return [
            models.DashboardViewState,
        ];
    }

    fixupFields() {
    }

}
